module.exports = __webpack_public_path__ + "img/sharing.970f5dbb.jpg";